export const createNotificationsSlice = (set) => ({
  notifications: [],
  
  addNotification: (notification) => set((state) => ({
    notifications: [...state.notifications, {
      id: Date.now(),
      type: 'info',
      duration: 5000,
      ...notification
    }]
  })),

  removeNotification: (id) => set((state) => ({
    notifications: state.notifications.filter(notif => notif.id !== id)
  })),

  clearNotifications: () => set({ notifications: [] }),
});
